import React from "react";
import BayrampasaSidebar from "../Sidebar/BayrampasaSidebar";
import BayrampasaOtherServices from "../ServiceAreas/BayrampasaServiceArea";
// import BadgeSection from "../../BadgeSection";
import LeftSidebar from "../../Sidebars/LeftSidebar";
import RightSidebar from "../../Sidebars/RightSidebar";

const BayrampasaIntro = () => {
  return (
    <div className="bg-white text-black py-10 px-4 max-w-screen-xl mx-auto">
      <h1 className="mt-0 text-2xl text-center font-bold text-[#003132] mb-4">
        BAYRAMPAŞA HALI-KOLTUK YIKAMA
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        {/* İçerik */}
        <div className="order-1 md:order-2 md:col-span-2 space-y-6">
          <p>
            Bayrampaşa'da yoğun şehir temposu ve apartman yaşamı, halı ve koltukların
            hızla kirlenmesine neden olur. İstanbul Temizlik Servisi olarak sunduğumuz
            hizmetlerle, bu sorunlara profesyonel ve hijyenik çözümler getiriyoruz.
          </p>

          <p>
            Halılarınız cinsine uygun otomatik makinelerde yıkanır, koltuklarınız ise
            buharlı ve köpüklü sistemlerle detaylı şekilde temizlenir. Böylece evinizde
            hijyenik ve sağlıklı bir ortam oluşturulmasına katkı sağlarız.
          </p>

          <p>
            <strong>Bayrampaşa halı yıkama hizmetimizin avantajları:</strong>
          </p>

          <ul className="list-disc list-inside">
            <li>Bayrampaşa genelinde ücretsiz servis: Kapıdan alım ve teslimat</li>
            <li>Leke çıkartma garantili koltuk ve halı temizliği</li>
            <li>Organik ve alerjen içermeyen temizlik ürünleri</li>
            <li>Perde, yorgan, battaniye yıkama hizmetleri</li>
            <li>Yerinde koltuk yıkama seçeneği</li>
            <li>48 saat içinde hızlı ve güvenli teslimat</li>
          </ul>

          <p>
            Muratpaşa, Altıntepsi, Terazidere, Kartaltepe gibi Bayrampaşa’nın tüm mahallelerine
            mobil araçlarımızla hızlı şekilde hizmet veriyoruz. Halılar toz alma, yıkama ve
            kurutma aşamalarından geçirilerek profesyonelce teslim edilir.
          </p>

          <p>
            Kampanyalı fiyatlarımız ve bölgeye özel hizmet detayları için bizimle hemen
            iletişime geçebilirsiniz. Sağlığınız ve memnuniyetiniz önceliğimizdir.
          </p>

          {/* Mahalle sidebar ve hizmet bölgeleri */}
          <BayrampasaSidebar />
          <BayrampasaOtherServices />
        </div>

        {/* Sol Sidebar */}
        <div className="order-2 md:order-1 space-y-6">
          <LeftSidebar />
        </div>

        {/* Sağ Sidebar */}
        <div className="order-3 md:order-3 space-y-6">
          <RightSidebar />
        </div>
      </div>
    </div>
  );
};

export default BayrampasaIntro;
